module.exports = __webpack_public_path__ + "static/02-f994d9793c2726056cc032bbceea4a2f.jpg";